export const css = {
	root: 'N8tId3vC',
	' _key': 'ascm-theme/ascm/variants/ascm2024demo'
};

export default css;
